import { RightSideBarModule } from '../../right-side-bar-service/core/right-side-bar-module';
import { INotifyManager, MODULE_NAME } from '@src/slide/application/service/notify-manager/core/notify-manager.interface';

export class NotifyRSBarModule extends RightSideBarModule {
    public constructor(private notifyManager: INotifyManager) {
        super();
    }

    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    public get name() {
        return MODULE_NAME;
    }
    public show() {
        this.notifyManager.showNotifyModule(this.DOMNode as HTMLElement, () => {
            this.showWrapper();
        }, () => {
            this.hideWrapper();
        });
    }
}
